import { INVITACION } from '../lib/demo.js';

/**
 * El aviso de que esto es una demostración, arriba de la página de reservas.
 *
 * ─── Por qué arriba de todo y pegada ───────────────────────────────────────
 *
 * Porque la reserva son cinco pantallas y la confirmación. Si el aviso saliera
 * sólo en la primera, quien llega al final ya se olvidó de que era una demo, y
 * el momento en que más importa que lo sepa es justo cuando aprieta
 * «Confirmar».
 *
 * ─── Y por qué además invita ───────────────────────────────────────────────
 *
 * Sin el link, el demo es un callejón sin salida: alguien saca un turno de
 * prueba, ve que funciona, y se queda ahí. Esta es la única barra de la
 * aplicación que empuja hacia el registro, y existe para que la demo trabaje a
 * favor del alta en vez de competirle.
 */
export function BarraDemo() {
  return (
    <div className="demo-barra" role="region" aria-label="Aviso de demostración">
      {/* Sin el rubro adentro: las demos son dos —una barbería y un club de
          canchas— y esta barra se dibuja afuera de ReservaEnCurso, que es
          quien conoce el negocio. "Una demostración" dice lo mismo que "una
          barbería de demostración" y sirve para las dos. */}
      <p className="demo-barra-texto">
        <strong>Esto es una demostración.</strong> Podés reservar para ver cómo
        lo vive tu cliente: el turno no es real.
      </p>
      <a className="demo-barra-link" href="/registro">{INVITACION}</a>
    </div>
  );
}
